export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      file: {
        fileId: 1,
        fileUuid: "files001",
        fileName: "bg_cafe.jpg",
        fileUri: "/images/img01.png",
        thumbnailUri: "/images/img01.png",
        fileContentsType: "application/pdf",
        serviceKbn: 1,
        services: [
          {
            serviceUuid: "xxxxxx",
            serviceName: "xxxxxx"
          }
        ],
        createdAt: 1234567890123,
        updatedAt: 1234567890123
      }
    }
  }
}